/**
 * The signed-in account's organizations. Airview Studio is free-only (VLP-2566): every account gets every feature,
 * there are no plans, tiers or purchases, and aircraft data is bring-your-own-key only.
 */
import { create } from 'zustand';
import type { Organization } from '@apos/shared';
import { request } from '../lib/api';

export interface AccountInfo { organizations: Organization[] }

interface AccountState {
  data: AccountInfo | null;
  load(): Promise<void>;
  reset(): void;
}

export const useAccount = create<AccountState>((set) => ({
  data: null,
  async load() {
    try {
      const mine = await request<{ organizations?: Organization[]; organization?: Organization | null }>('GET', '/me/organization');
      set({ data: { organizations: mine.organizations ?? (mine.organization ? [mine.organization] : []) } });
    } catch { /* the app works without it; organization hints stay hidden */ }
  },
  reset() { set({ data: null }); },
}));

/** The organization a new fleet aircraft goes to: the first one this account administers, or none (a personal fleet). */
export function fleetOrganization(data: AccountInfo | null): Organization | null {
  return data?.organizations.find((o) => o.role === 'admin') ?? null;
}
